export default __webpack_public_path__ + "static/media/new_m2_video_ntF.95e2a0ac.png";